import React, { useCallback, useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { StepContainer, TagSetupInstallManuallyStepView } from '@bingads-webui-campaign-react/goal-creation-wizard';
import { UetSetupWizardContext } from '../../uet-setup-wizard-context';

const TagSetupInstallManuallyStepUnwrapped = () => {
  const wizardContext = useContext(UetSetupWizardContext);
  const i18n = useContext(I18nContext);

  const { logActivity } = wizardContext;
  const { Id: tagId } = wizardContext.tagContext;

  const handleCancel = useCallback(() => {
    wizardContext.exitWizard();
  }, [wizardContext]);

  const footerConfig = useMemo(() => ({
    buttons: [{
      type: 'Secondary',
      onClick: wizardContext.goBack,
      isEnabled: true,
      text: i18n.getString(_TL_(('Back'))),
    },
    {
      type: 'Primary',
      onClick: wizardContext.goNext,
      isEnabled: true,
      text: i18n.getString(_TL_(('Next'))),
    },
    {
      type: 'Cancel',
      onClick: handleCancel,
      isEnabled: true,
      text: i18n.getString(_TL_(('Cancel'))),
    }],
  }), [wizardContext.goBack, wizardContext.goNext, i18n, handleCancel]);

  return (
    <StepContainer
      subContainer
      step="tag-setup-selection"
      footerConfig={footerConfig}
      title={i18n.getString(_TL_('Add the tag manually'))}
    >
      <TagSetupInstallManuallyStepView
        i18n={i18n}
        tagId={tagId}
        uetTagInstructions={wizardContext.tagTemplates.UETTagInstructions}
        logActivity={logActivity}
        wizardDispatch={wizardContext.dispatch}
        tagTemplates={wizardContext.tagTemplates}
      />
    </StepContainer>

  );
};

export const TagSetupInstallManuallyStep = TagSetupInstallManuallyStepUnwrapped;
